export default __webpack_public_path__ + "media/flags/lv-d56a0998.svg";